/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerEnquiry as ModelsCustomerCustomerEnquiry } from '../../models/Models/Customer/customer-enquiry';

export interface V3CustomersMeEnquiryPost$Json$Xml$Params {
      body?: ModelsCustomerCustomerEnquiry
}

export function v3CustomersMeEnquiryPost$Json$Xml(http: HttpClient, rootUrl: string, params?: V3CustomersMeEnquiryPost$Json$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerEnquiry>> {
  const rb = new RequestBuilder(rootUrl, v3CustomersMeEnquiryPost$Json$Xml.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/xml', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsCustomerCustomerEnquiry>;
    })
  );
}

v3CustomersMeEnquiryPost$Json$Xml.PATH = '/v3/customers/me/enquiry';
